// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line[data-v-71be2d70]{font-family:Menlo,Consolas,monospace;color:var(--logs-text);display:flex}.time[data-v-71be2d70]{white-space:nowrap;display:none;width:0;padding-right:15px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.msg[data-v-71be2d70]{white-space:pre}.msg .highlight[data-v-71be2d70]{color:var(--logs-highlight);background-color:var(--logs-highlight-bg)}", ""]);
// Exports
module.exports = exports;
